import { WEBUILogs } from "../logging";
import getLocaleWeekFirstDayNumber from "./getLocaleWeekFirstDayNumber";

export default function(locale = "en-US", referenceDate) {
    if (!referenceDate || referenceDate.constructor !== Date) {
        WEBUILogs.error("getLocaleDistanceToWeedStart: bad referenceDate: " + referenceDate);
    } else {
        let dayIndex = referenceDate.getDay();
        let localDayStart = getLocaleWeekFirstDayNumber(locale);

        let distance = dayIndex - localDayStart;
        if (distance < 0) {
            distance = 7 + distance;
        }

        return distance;
    }
}
